import React from 'react'
import { Card, List, Typography } from 'antd'
import Vimeo from '@u-wave/react-vimeo'
import ReactPlayer from 'react-player'

const { Title, Text } = Typography;

const CourseDetails = (props) => {

    const getVideo = (url) =>{ 

        if (url.includes("vimeo")){
            return (
                <Vimeo
                    video={url}
                    responsive
                    color={"14e3ba"}
                    controls={true}
                    showTitle={false}
                />
            )
        }else{
            return (
                <div className="player-wrapper">
                    <ReactPlayer
                        className='react-player'
                        url={url}
                        width="100%"
                        height="100%"
                        controls={true}
                    />
                </div>
            )
        }
    }

    return (
        <Card
            title={props.product.title}
            style={{
                borderRadius: 10, 
                marginBottom: 25,
                boxShadow: "5px 8px 24px 5px rgba(208, 216, 243, 0.6)" 
            }}
        >
            { props.product.introVideo &&
                    getVideo(props.product.introVideo)
            }
            <div
                dangerouslySetInnerHTML={{
                __html: props.product.description
                }}>
            </div>
            <List
                itemLayout="horizontal"
                header={<Title level={5}>Lessons</Title>}
                footer={<Text type="secondary" >If you have questions, make sure to contact me at matt@odinplatform.com</Text>}
                dataSource={props.product.lessons}
                renderItem={item => (
                <List.Item>
                    <List.Item.Meta
                    title={item.title}
                    description={item.description}
                    />
                </List.Item>
                )}
            />
        </Card>
    )
}

export default CourseDetails
